import noop from 'lodash/noop';

import ImageCropperModal from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/image_cropper/image_cropper_container.jsx';
import SectionBackgroundAssetCropperModal from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/section_background_asset_cropper_container.jsx';
import { getCroppableImageUrlFromAsset } from 'zoomforth_codesbane_editor/lib/assets.js';
import { setContentItemSimpleData } from './content.js';
import { setTileIsLoading } from './sections.grid.js';
import { setSectionAndOverrides } from './sections.js';
import { isShowingOptimizedImage } from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';
import { showModal } from './editor_modals.js';
import { setAndUpdateAssetData } from './asset.js';
import { getCachedCroppedZfImageFromAsset } from 'zoomforth_codesbane_editor/lib/assets.js';
import { isAssetTypeCroppable } from 'zoomforth_media_library/lib/assets.js';
import {
  showErrorNotification
} from './misc.js';
import {
  updateSectionBackgroundData,
  updateSectionFallbackBackgroundData
} from 'zoomforth_codesbane_editor/action_creators/sections.js';
import {
  getIdFrom,
  getUuidFrom
} from 'zoomforth_codesbane_viewer/lib/id_utils.js';
import {
  getSectionById,
  getAssetForContent,
  getSectionForContent,
  getContentItemByUuid,
  getSectionBackgroundData,
  getSectionFallbackBackgroundData
} from 'zoomforth_codesbane_viewer/reducers/index.js';
import {
  toTileAspectRatioString,
  getTrueTileAspectRatio
} from 'zoomforth_codesbane_viewer/lib/aspect_ratios.js';
import {
  getCroppableImageUrlFromContent,
  getTileAspectRatioForCropping
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

export const createCroppedImage = (newZfImage) =>
  $.ajax({
    url: '/asset_tools/crop',
    type: 'POST',
    dataType: 'json',
    data: {
      'zfImage': JSON.stringify(newZfImage)
    }
  });

export const createCroppedImageForTile = (contentItemOrUuid, zfImage, shouldClearCachedCrops) =>
  (dispatch, getState) => {
    const contentItemUuid = getUuidFrom(contentItemOrUuid);
    const contentItem = getContentItemByUuid(getState(), contentItemUuid);
    const section = getSectionForContent(getState(), contentItem);
    const { sizex, sizey } = getTileAspectRatioForCropping(section, contentItem);
    const asset = getAssetForContent(getState(), contentItem);
    const dimensions = toTileAspectRatioString({ sizex, sizey });

    dispatch(setTileIsLoading(contentItemOrUuid, true));
    createCroppedImage(zfImage)
      .done((zfImage) => {
        dispatch(setContentItemSimpleData(contentItemUuid, { tile_inner_zf_image: zfImage }));
        if (asset) {

          var cachedCrops = {
            ...asset.cachedCrops,
            [dimensions]: zfImage
          };

          if (shouldClearCachedCrops) {
            cachedCrops = {
              [dimensions]: zfImage
            };
          }

          dispatch(setAndUpdateAssetData({ ...asset, cachedCrops }));
        }
        dispatch(setTileIsLoading(contentItemOrUuid, false));
      })
      .fail((xhr) => {
        dispatch(setTileIsLoading(contentItemOrUuid, false));
        let message;
        try {
          message = JSON.parse(xhr.responseText).error.message;
        } catch (e) {
          message = 'We could not create a crop from this image.';
        }

        dispatch(showErrorNotification('Cropping failed', message));
      });
  };

export const createCroppedImageForSectionBackground = (contentItemOrUuid, section, zfImage) =>
  (dispatch) => {
    const contentUuid = getUuidFrom(contentItemOrUuid);

    dispatch(setSectionAndOverrides(section.id, section, { isLoading: true }));

    createCroppedImage(zfImage)
      .done((zfImage) => {
        dispatch(setContentItemSimpleData(contentUuid, { section_background_zf_image: zfImage }));
        dispatch(setSectionAndOverrides(section.id, section, { isLoading: false }));
      })
      .fail((xhr) => {
        dispatch(setSectionAndOverrides(section.id, section, { isLoading: false }));

        let message;
        try {
          message = JSON.parse(xhr.responseText).error.message;
        } catch (e) {
          message = 'We could not create a crop from this image.';
        }

        dispatch(showErrorNotification('Cropping failed', message));

      });
  };

const isCroppableImage = (contentItem) => {
  if(contentItem.tile_inner_zf_image){
    return !contentItem.tile_inner_zf_image.isUncroppable;
  }

  // Handles legacy tiles which don't yet use the zfImage object
  return !!isAssetTypeCroppable(contentItem.asset_type);
};

export const cropTileIfNeeded = ({ uuid, sizex, sizey }) =>
  (dispatch, getState) => {
    const contentItem = getContentItemByUuid(getState(), uuid);
    const asset = getAssetForContent(getState(), contentItem);

    if(isCroppableImage(contentItem)){
      const zfImage = getCachedCroppedZfImageFromAsset(asset, { sizex, sizey });
      if (zfImage) {
        dispatch(setContentItemSimpleData(uuid, { tile_inner_zf_image: zfImage }));
      } else {
        dispatch(showCropperForTile({ contentItem }));
      }
    }
  };

export const cropTileFromContentItemIfNeeded = ({ contentItem, sizex, sizey }) =>
  (dispatch, getState) => {
    const uuid = getUuidFrom(contentItem);
    const asset = getAssetForContent(getState(), contentItem);

    if (isCroppableImage(contentItem)) {
      const zfImage = getCachedCroppedZfImageFromAsset(asset, { sizex, sizey });

      if (zfImage) {
        dispatch(setContentItemSimpleData(uuid, { tile_inner_zf_image: zfImage }));
      } else {
        dispatch(showCropperForTile({ contentItem }));
      }
    }
  };

export const showCropperForTile = ({ contentItem, onCancel = noop, onFail = noop, hasCompressionChanged=false, shouldClearCachedCrops=false }) =>
  (dispatch, getState) => 
    dispatch(showModal(ImageCropperModal, {
      ...getLegacyTileCropperProps(contentItem, { getState }),
      zfImage: contentItem.tile_inner_zf_image,
      aspectRatio: getTileAspectRatio(contentItem, { getState }),
      onSuccess: (zfImage) => {
        dispatch(createCroppedImageForTile(contentItem, zfImage, shouldClearCachedCrops));
      },
      hasCompressionChanged,
      onCancel,
      onFail
    }));


const getTileAspectRatio = (contentItem, { getState }) => {
  const section = getSectionForContent(getState(), contentItem);
  const tileAspectRatioForCropping = getTileAspectRatioForCropping(section, contentItem);
  const { sizex, sizey } = getTrueTileAspectRatio(tileAspectRatioForCropping);

  return sizex / sizey;
};

export const getLegacyTileCropperProps = (contentItem, { getState }) => {
  if (contentItem.tile_inner_zf_image) {
    return {};
  }

  const asset = getAssetForContent(getState(), contentItem);
  const forcePng = !isShowingOptimizedImage(contentItem, asset);
  const imageSrc = getCroppableImageUrlFromContent(contentItem, asset);

  return {
    legacyImageSrc: imageSrc,
    legacyCropData: contentItem.crop_data,
    legacyForcePng: forcePng,
  };
};

export const showCropperForSectionBackgroundAsset = (sectionOrId, { useUncompressedImage = false, hasCompressionChanged=false, dataKey = 'backgroundData' } = {}) =>
  (dispatch, getState) => {
    const sectionId = getIdFrom(sectionOrId);
    const section = getSectionById(getState(), sectionId);
    const { contentItem, asset, backgroundZfImage } = getSectionBackgroundData(getState(), section, dataKey);
    const legacyImageSrc = useUncompressedImage ? asset.originalImage : getCroppableImageUrlFromAsset(asset);

    var zfImage = backgroundZfImage;
    if(hasCompressionChanged){
      zfImage = {
        ...backgroundZfImage,
        isUncompressed: useUncompressedImage // cropping is required for this change to take effect
      };
  
      if(zfImage.cropData){
        zfImage.cropData.originalImageSrc = useUncompressedImage ? asset.originalImage : asset.displayImage;
      }else{
        zfImage.src = useUncompressedImage ? asset.originalImage : asset.displayImage;
      }
    }

    const onSuccess = (zfImage) => {
      createCroppedImage(zfImage)
        .done((zfImage) => {
          dispatch(updateSectionBackgroundData(sectionId, {
            backgroundType: 'image',
            backgroundZfImage: zfImage
          }, dataKey));
        })
        .fail((xhr) => {
          dispatch(setSectionAndOverrides(section.id, section, { isLoading: false }));
          let message;
          try {
            message = JSON.parse(xhr.responseText).error.message;
          } catch (e) {
            message = 'We could not create a crop from this image.';
          }
          dispatch(showErrorNotification('Cropping failed', message));
        });
    };

    dispatch(showModal(SectionBackgroundAssetCropperModal, {
      section,
      contentItem,
      asset,
      legacyImageSrc,
      zfImage,
      hasCompressionChanged,
      isBorderRadiusDisabled: true,
      onSuccess
    }));
  };

export const showCropperForSectionFallbackBackgroundAsset = (sectionOrId, { useUncompressedImage = false } = {}) =>
  (dispatch, getState) => {
    const sectionId = getIdFrom(sectionOrId);
    const section = getSectionById(getState(), sectionId);
    const { contentItem, asset, backgroundZfImage } = getSectionFallbackBackgroundData(getState(), section);
    const legacyImageSrc = useUncompressedImage ? asset.originalImage : getCroppableImageUrlFromAsset(asset);

    const onSuccess = (zfImage) => {
      createCroppedImage(zfImage)
        .done((zfImage) => {
          dispatch(updateSectionFallbackBackgroundData(sectionId, {
            backgroundType: 'image',
            backgroundZfImage: zfImage
          }));
        })
        .fail((xhr) => {
          dispatch(setSectionAndOverrides(section.id, section, { isLoading: false }));
          let message;
          try {
            message = JSON.parse(xhr.responseText).error.message;
          } catch (e) {
            message = 'We could not create a crop from this image.';
          }
          dispatch(showErrorNotification('Cropping failed', message));
        });
    };

    dispatch(showModal(SectionBackgroundAssetCropperModal, {
      section,
      contentItem,
      asset,
      legacyImageSrc,
      zfImage: {
        ...backgroundZfImage,
        isUncompressed: useUncompressedImage
      },
      isBorderRadiusDisabled: false,
      onSuccess
    }));
  };
